import React, { useState } from 'react'
import {Link} from 'react-router-dom'
import './ForgotPassword.css'
import './Register.css'
import {auth} from "./firebase";
import EmailIcon from '@mui/icons-material/Email';

function ForgotPassword() {
    const [resetEmail,setResetEmail]=useState('')
    const resetPassword=(event)=>{
        event.preventDefault();
        // const auth = firebase.auth();

        auth.sendPasswordResetEmail(resetEmail).then(()=> {
            alert('Reset Password Link sent to your mail')
        }).catch( (error)=> {
            alert(error.message)
        });
        
    }
    return (
        <div className='forgotpassword'>
           <div className="forgotpassword__container">
                <form>
                    <h5 className='mb-3'>Reset Password</h5>
                    <p>Enter your email to reset password</p>
                    
                    <p className='inputWithIcon'>
                    <input placeholder='Email ' className='mail' type="email" onChange={(e)=>{setResetEmail(e.target.value)}}/>
                    <i className='email__icon'><EmailIcon/></i>
                    </p>
                    
                    <button onClick={resetPassword} className='forgotpassword__button'>Send</button>
                    <p className='text-center mt-3 text-decoration-none'><Link to='login' >back to login</Link></p>
                </form>
            </div>
        </div>
    )
}

export default ForgotPassword
